export { default } from './ZoomLinkOut';
